import React, { createRef, Fragment, useEffect, useState } from 'react';
import { change, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { email, maxAgePet, number, required } from './../../helper/validation';
import { birthday, cpf, phone, phoneCell, zipCode } from './../../helper/mask';
import axios from 'axios';
import api from './../../service/api';
import { isUndefined } from 'lodash';
import * as PropTypes from 'prop-types';

import Alert from './../../components/Alert';
import { GroupRadioForm, InputForm, SelectForm, TextAreaForm } from './../ReduxForm';
import { ButtonGroup, Container, FormGroup, Row, SubTitle, Title } from './style';
import { Button } from 'semantic-ui-react';

const alertRef = createRef();

const Form = (props) => {
  const { reset, form, dispatch, forms, invalid, submitting, pristine, handleClose, createToken } = props;

  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [breeds, setBreeds] = useState([]);

  /**
   * Envia formulário para API de pagamentos.
   *
   * @param ev
   * @returns {Promise<void>}
   */
  const handleSubmit = async (ev) => {
    const { values } = props.forms;
    const amigooToken = JSON.parse(sessionStorage.getItem('amigooPet'));

    await ev.preventDefault();
    await setSubmit(true);
    await handleClose(false);

    try {
      const birth_pet = `${values.pet.birth_date.substring(4)}-${values.pet.birth_date.substring(2, 4)}-${values.pet.birth_date.substring(0, 2)}`;
      const birth_people = `${values.insurance_holder.birth_date.substring(4)}-${values.insurance_holder.birth_date.substring(2, 4)}-${values.insurance_holder.birth_date.substring(0, 2)}`;

      const quote = await api.post(`/quote/5`, {
        pets: [
          {
            birth_date: birth_pet,
          },
        ],
        payment: { ...values.payment },
        product_data: { ...values.product_data },
        product_ids: [...values.product_ids],
      }, {
        headers: {
          token: amigooToken.token,
        },
      });

      const { contract_uuid } = quote.data.data;

      await api.post(`/enroll/${contract_uuid}`, {
        pets: [values.pet],
        insurance_holder: {
          phones: [
            {
              type: 'mobile',
              number: values.insurance_holder.phone.phone_cell.substring(2),
              area_code: values.insurance_holder.phone.phone_cell.substring(0, 2),
            }, {
              type: 'landline',
              number: values.insurance_holder.phone.phone.substring(2),
              area_code: values.insurance_holder.phone.phone.substring(0, 2),
            },
          ],
          addresses: [values.insurance_holder.address],
          cpf: values.insurance_holder.cpf,
          name: values.insurance_holder.name,
          email: values.insurance_holder.email,
          birth_date: birth_people,
        },
        payment: {
          id_opcao_pagamento: 1,
        },
      }, {
        headers: {
          token: amigooToken.token,
        },
      });

      await alertRef.current.toggleModal({
        success: true,
        title: 'Parabéns!',
        subtitle: 'Contratação realizada com sucesso! O certificado do seu plano será enviado para você no e-mail cadastrado.',
      });
      await reset();
    } catch (e) {
      await console.log(e);
      await sessionStorage.removeItem('amigooPet');
      await alertRef.current.toggleModal({
        success: false,
        title: 'Ooops...',
        subtitle: 'Houve um erro ao cadastrar sua solicitação. Por favor, tente novamente, caso o erro persista entre em contato conosco.',
      });
      await createToken();
    } finally {
      await setSubmit(false);
      await handleClose(true);
    }

  };

  /**
   * Busca endereço a partir do Cep informado.
   *
   * @param zip
   * @returns {Promise<void>}
   */
  const handleLocation = async (zip) => {
    await setLoading(true);

    try {
      const location = await axios.get(`https://viacep.com.br/ws/${zip}/json/unicode/`);
      const { bairro, logradouro, localidade, uf } = location.data;

      await dispatch(change(form, 'insurance_holder.address.district', bairro));
      await dispatch(change(form, 'insurance_holder.address.street', logradouro));
      await dispatch(change(form, 'insurance_holder.address.city', localidade));
      await dispatch(change(form, 'insurance_holder.address.state', uf));
    } catch (e) {
      await console.log(e);
    }

    await setLoading(false);
  };

  /**
   * Retorna os tipos de raça.
   *
   * @param type
   * @returns {Promise<Array>}
   */
  const handleBreed = async (type) => {
    switch (type) {
      case 'Cao':
        await setBreeds([
          { key: 0, text: 'Affenpinscher', value: 'Affenpinscher' },
          { key: 1, text: 'Afghan Hound', value: 'Afghan Hound' },
          { key: 2, text: 'Airedale Terrier', value: 'Airedale Terrier' },
          { key: 3, text: 'Akita', value: 'Akita' },
          { key: 4, text: 'Akita Americano', value: 'Akita Americano' },
          { key: 5, text: 'American Pit Bull Terrier', value: 'American Pit Bull Terrier' },
          { key: 6, text: 'American Staffordshire Terrier', value: 'American Staffordshire Terrier' },
          { key: 7, text: 'Australian Shepherd', value: 'Australian Shepherd' },
          { key: 8, text: 'Basenji', value: 'Basenji' },
          { key: 9, text: 'Basset Fulvo da Bretanha', value: 'Basset Fulvo da Bretanha' },
          { key: 10, text: 'Basset Hound', value: 'Basset Hound' },
          { key: 11, text: 'Beagle', value: 'Beagle' },
          { key: 12, text: 'Beagle-Harrier', value: 'Beagle-Harrier' },
          { key: 13, text: 'Bearded Collie', value: 'Bearded Collie' },
          { key: 15, text: 'Bedlington Terrier', value: 'Bedlington Terrier' },
          { key: 14, text: 'Bernese Mountain Dog', value: 'Bernese Mountain Dog' },
          { key: 16, text: 'Bichon Bolonhês', value: 'Bichon Bolonhês' },
          { key: 17, text: 'Bichon Frise', value: 'Bichon Frise' },
          { key: 18, text: 'Bichon Havanês', value: 'Bichon Havanês' },
          { key: 19, text: 'Boerboel', value: 'Boerboel' },
          { key: 20, text: 'Boiadeiro de Entlebuch', value: 'Boiadeiro de Entlebuch' },
          { key: 21, text: 'Border Collie', value: 'Border Collie' },
          { key: 22, text: 'Border Terrier', value: 'Border Terrier' },
          { key: 23, text: 'Borzoi', value: 'Borzoi' },
          { key: 24, text: 'Boston Terrier', value: 'Boston Terrier' },
          { key: 25, text: 'Bouvier de Flandres', value: 'Bouvier de Flandres' },
          { key: 26, text: 'Boxer', value: 'Boxer' },
          { key: 27, text: 'Braco Alemão Pelo Curto', value: 'Braco Alemão Pelo Curto' },
          { key: 28, text: 'Braco Alemão Pelo Duro', value: 'Braco Alemão Pelo Duro' },
          { key: 29, text: 'Braco Italiano', value: 'Braco Italiano' },
          { key: 30, text: 'Buldogue Americano', value: 'Buldogue Americano' },
          { key: 31, text: 'Buldogue Francês', value: 'Buldogue Francês' },
          { key: 32, text: 'Buldogue Inglês', value: 'Buldogue Inglês' },
          { key: 33, text: 'Bull Terrier', value: 'Bull Terrier' },
          { key: 34, text: 'Bullmastiff', value: 'Bullmastiff' },
          { key: 35, text: 'Cairn Terrier', value: 'Cairn Terrier' },
          { key: 36, text: 'Cane Corso', value: 'Cane Corso' },
          { key: 37, text: 'Cão de Crista Chinês', value: 'Cão de Crista Chinês' },
          { key: 38, text: 'Cão de Santo Humberto', value: 'Cão de Santo Humberto' },
          { key: 39, text: 'Cão dâ ã gua Espanhol', value: 'Cão dâ ã gua Espanhol' },
          { key: 40, text: 'Cão dâ ã gua Português', value: 'Cão dâ ã gua Português' },
          { key: 41, text: 'Cão Lobo Checoslovaco', value: 'Cão Lobo Checoslovaco' },
          { key: 43, text: 'Cão Pelado Mexicano', value: 'Cão Pelado Mexicano' },
          { key: 42, text: 'Cão Pelado Peruano', value: 'Cão Pelado Peruano' },
          { key: 45, text: 'Cavalier King Charles Spaniel', value: 'Cavalier King Charles Spaniel' },
          { key: 44, text: 'Cesky Terrier', value: 'Cesky Terrier' },
          { key: 46, text: 'Chesapeake Bay Retriever', value: 'Chesapeake Bay Retriever' },
          { key: 47, text: 'Chihuahua', value: 'Chihuahua' },
          { key: 48, text: 'Chin', value: 'Chin' },
          { key: 49, text: 'Chow-chow Pelo Curto', value: 'Chow-chow Pelo Curto' },
          { key: 50, text: 'Chow-chow Pelo Longo', value: 'Chow-chow Pelo Longo' },
          { key: 51, text: 'Cirneco do Etna', value: 'Cirneco do Etna' },
          { key: 52, text: 'Clumber Spaniel', value: 'Clumber Spaniel' },
          { key: 53, text: 'Cocker Spaniel Americano', value: 'Cocker Spaniel Americano' },
          { key: 55, text: 'Cocker Spaniel Inglês', value: 'Cocker Spaniel Inglês' },
          { key: 54, text: 'Collie pelo longo', value: 'Collie pelo longo' },
          { key: 56, text: 'Coton de Tulear', value: 'Coton de Tulear' },
          { key: 57, text: 'Dachshund Teckel - Pelo Curto', value: 'Dachshund Teckel - Pelo Curto' },
          { key: 58, text: 'Dalmata', value: ' DáDalmata' },
          { key: 59, text: 'Dandie Dinmont Terrier', value: ' Dandie Dinmont Terrier' },
          { key: 60, text: 'Dobermann', value: ' Dobermann' },
          { key: 61, text: 'Dogo Argentino', value: ' Dogo Argentino' },
          { key: 62, text: 'Dogo Canario', value: ' Dogo Canario' },
          { key: 63, text: 'Dogue Alemão', value: ' Dogue Alemão' },
          { key: 64, text: 'Dogue de Bordeaux', value: ' Dogue de Bordeaux' },
          { key: 65, text: 'Elkhound Norueguês Cinza', value: ' Elkhound Norueguês Cinza' },
          { key: 66, text: 'Fila Brasileiro', value: ' Fila Brasileiro' },
          { key: 67, text: 'Flat-Coated Retriever', value: ' Flat-Coated Retriever' },
          { key: 68, text: 'Fox Terrier Pelo Duro ', value: ' Fox Terrier Pelo Duro ' },
          { key: 69, text: 'Fox Terrier Pelo Liso', value: ' Fox Terrier Pelo Liso' },
          { key: 70, text: 'Foxhound Inglês', value: ' Foxhound Inglês' },
          { key: 71, text: 'Galgo Espanhol', value: ' Galgo Espanhol' },
          { key: 72, text: 'Golden Retriever', value: ' Golden Retriever' },
          { key: 73, text: 'Grande Munsterlander', value: ' Grande Munsterlander' },
          { key: 74, text: 'Greyhound', value: ' Greyhound' },
          { key: 75, text: 'Griffon Belga', value: ' Griffon Belga' },
          { key: 76, text: 'Griffon de Bruxelas', value: ' Griffon de Bruxelas' },
          { key: 77, text: 'Husky Siberiano', value: ' Husky Siberiano' },
          { key: 78, text: 'Ibizan Hound', value: ' Ibizan Hound' },
          { key: 79, text: 'Irish Soft Coated Wheaten Terrier', value: ' Irish Soft Coated Wheaten Terrier' },
          { key: 80, text: 'Irish Wolfhound', value: ' Irish Wolfhound' },
          { key: 81, text: 'Jack Russell Terrier', value: ' Jack Russell Terrier' },
          { key: 82, text: 'Kerry Blue Terrier', value: ' Kerry Blue Terrier' },
          { key: 83, text: 'Komondor', value: ' Komondor' },
          { key: 84, text: 'Kuvasz', value: ' Kuvasz' },
          { key: 85, text: 'Labrador Retriever', value: ' Labrador Retriever' },
          { key: 86, text: 'Lagotto Romagnolo', value: ' Lagotto Romagnolo' },
          { key: 87, text: 'Lakeland Terrier', value: ' Lakeland Terrier' },
          { key: 88, text: 'Leonberger', value: ' Leonberger' },
          { key: 89, text: 'Lhasa Apso', value: ' Lhasa Apso' },
          { key: 90, text: 'Malamute do Alasca', value: ' Malamute do Alasca' },
          { key: 91, text: 'Maltês', value: ' Maltês' },
          { key: 92, text: 'Mastiff', value: ' Mastiff' },
          { key: 93, text: 'Mastim Espanhol', value: ' Mastim Espanhol' },
          { key: 94, text: 'Mastino Napoletano', value: ' Mastino Napoletano' },
          { key: 95, text: 'Mudi', value: ' Mudi' },
          { key: 96, text: 'Nordic Spitz', value: ' Nordic Spitz' },
          { key: 97, text: 'Norfolk Terrier', value: ' Norfolk Terrier' },
          { key: 98, text: 'Norwich Terrier', value: ' Norwich Terrier' },
          { key: 99, text: 'Old English Sheepdog', value: ' Old English Sheepdog' },
          { key: 100, text: 'Papillon', value: ' Papillon' },
          { key: 101, text: 'Parson Russell Terrier', value: ' Parson Russell Terrier' },
          { key: 102, text: 'Pastor Alemão', value: ' Pastor Alemão' },
          { key: 103, text: 'Pastor Beauceron', value: ' Pastor Beauceron' },
          { key: 104, text: 'Pastor Belga', value: ' Pastor Belga' },
          { key: 105, text: 'Pastor Bergamasco', value: ' Pastor Bergamasco' },
          { key: 106, text: 'Pastor Branco Suiço', value: ' Pastor Branco Suiço' },
          { key: 107, text: 'Pastor Briard', value: ' Pastor Briard' },
          { key: 108, text: 'Pastor da Asia Central', value: ' Pastor da Asia Central' },
          { key: 109, text: 'Pastor de Shetland', value: ' Pastor de Shetland' },
          { key: 110, text: 'Pastor dos Pirineus', value: ' Pastor dos Pirineus' },
          { key: 111, text: 'Pastor Maremano Abruzês', value: ' Pastor Maremano Abruzês' },
          { key: 112, text: 'Pastor Polonês', value: ' Pastor Polonês' },
          { key: 113, text: 'Pastor Polonês da Planécie', value: ' Pastor Polonês da Planécie' },
          {
            key: 114,
            text: 'Pequeno Basset Griffon da Vendéia',
            value: ' Pequeno Basset Griffon da Vendéia',
          },
          { key: 115, text: 'Pequeno Cão Leão', value: ' Pequeno Cão Leão' },
          { key: 116, text: 'Pequeno Lebrel Italiano', value: ' Pequeno Lebrel Italiano' },
          { key: 117, text: 'Pequinês', value: ' Pequinês' },
          { key: 118, text: 'Perdigueiro Português', value: ' Perdigueiro Português' },
          { key: 119, text: 'Petit Brabançon', value: ' Petit Brabançon' },
          { key: 120, text: 'Pharaoh Hound', value: ' Pharaoh Hound' },
          { key: 121, text: 'Pinscher Miniatura', value: ' Pinscher Miniatura' },
          { key: 122, text: 'Podengo Canário', value: ' Podengo Canário' },
          { key: 123, text: 'Podengo Português', value: ' Podengo Português' },
          { key: 124, text: 'Pointer Inglês', value: ' Pointer Inglês' },
          { key: 125, text: 'Poodle Anão', value: ' Poodle Anão' },
          { key: 126, text: 'Poodle Médio', value: ' Poodle Médio' },
          { key: 127, text: 'Poodle Standard', value: ' Poodle Standard' },
          { key: 128, text: 'Poodle Toy', value: ' Poodle Toy' },
          { key: 129, text: 'Pug', value: ' Pug' },
          { key: 130, text: 'Puli', value: ' Puli' },
          { key: 131, text: 'Pumi', value: ' Pumi' },
          { key: 132, text: 'Rhodesian Ridgeback', value: ' Rhodesian Ridgeback' },
          { key: 133, text: 'Rottweiler', value: ' Rottweiler' },
          { key: 134, text: 'Saluki', value: ' Saluki' },
          { key: 135, text: 'Samoieda', value: ' Samoieda' },
          { key: 136, text: 'São Bernardo', value: ' São Bernardo' },
          { key: 137, text: 'Schipperke', value: ' Schipperke' },
          { key: 138, text: 'Schnauzer', value: ' Schnauzer' },
          { key: 139, text: 'Schnauzer Gigante', value: ' Schnauzer Gigante' },
          { key: 140, text: 'Schnauzer Miniatura', value: ' Schnauzer Miniatura' },
          { key: 141, text: 'Scottish Terrier', value: ' Scottish Terrier' },
          { key: 142, text: 'Sealyham Terrier', value: ' Sealyham Terrier' },
          { key: 143, text: 'Setter Gordon', value: ' Setter Gordon' },
          { key: 144, text: 'Setter Inglês', value: ' Setter Inglês' },
          { key: 145, text: 'Setter Irlandês Vermelho', value: ' Setter Irlandês Vermelho' },
          {
            key: 146,
            text: 'Setter Irlandês Vermelho e Branco',
            value: ' Setter Irlandês Vermelho e Branco',
          },
          { key: 147, text: 'Shar-pei', value: ' Shar-pei' },
          { key: 148, text: 'Shiba', value: ' Shiba' },
          { key: 149, text: 'Shih-Tzu', value: ' Shih-Tzu' },
          { key: 150, text: 'Silky Terrier Australiano', value: ' Silky Terrier Australiano' },
          { key: 151, text: 'Skye Terrier', value: ' Skye Terrier' },
          { key: 152, text: 'Smoushond Holandês', value: ' Smoushond Holandês' },
          { key: 153, text: 'Spaniel Bretão', value: ' Spaniel Bretão' },
          { key: 154, text: 'Spinone Italiano', value: ' Spinone Italiano' },
          { key: 155, text: 'Spitz Alemão Anão', value: ' Spitz Alemão Anão' },
          { key: 156, text: 'Spitz Finlandês', value: ' Spitz Finlandês' },
          { key: 157, text: 'Spitz Japonês Anão', value: ' Spitz Japonês Anão' },
          { key: 158, text: 'Springer Spaniel Inglês', value: ' Springer Spaniel Inglês' },
          { key: 159, text: 'Stabyhoun', value: ' Stabyhoun' },
          { key: 160, text: 'Staffordshire Bull Terrier', value: ' Staffordshire Bull Terrier' },
          { key: 161, text: 'Terra Nova', value: ' Terra Nova' },
          { key: 162, text: 'Terrier Alemão de caça Jagd', value: ' Terrier Alemão de caça Jagd' },
          { key: 163, text: 'Terrier Brasileiro', value: ' Terrier Brasileiro' },
          {
            key: 164,
            text: 'Terrier Irlandês de Glen do Imaal',
            value: ' Terrier Irlandês de Glen do Imaal',
          },
          { key: 165, text: 'Terrier Preto da Rússia', value: ' Terrier Preto da Rússia' },
          { key: 166, text: 'Tibetan Terrier', value: ' Tibetan Terrier' },
          { key: 167, text: 'Tosa Inu', value: ' Tosa Inu' },
          { key: 168, text: 'Vira-Latas', value: ' Vira-Latas' },
          { key: 169, text: 'Vizsla', value: ' Vizsla' },
          { key: 170, text: 'Volpino Italiano', value: ' Volpino Italiano' },
          { key: 171, text: 'Weimaraner', value: ' Weimaraner' },
          { key: 172, text: 'Welsh Corgi Cardigan', value: ' Welsh Corgi Cardigan' },
          { key: 173, text: 'Welsh Corgi Pembroke', value: ' Welsh Corgi Pembroke' },
          { key: 174, text: 'Welsh Springer Spaniel', value: ' Welsh Springer Spaniel' },
          { key: 175, text: 'Welsh Terrier', value: ' Welsh Terrier' },
          { key: 176, text: 'West Highland White Terrier', value: ' West Highland White Terrier' },
          { key: 177, text: 'Whippet', value: ' Whippet' },
          { key: 178, text: 'Yorkshire Terrier', value: ' Yorkshire Terrier' },
          { key: 179, text: 'Outro', value: 0 },
        ]);
        break;
      case 'Gato':
        await setBreeds([
          { key: 0, text: 'Abyssinian', value: 'Abyssinian' },
          { key: 1, text: 'American Bobtail Longhair', value: 'American Bobtail Longhair' },
          { key: 2, text: 'American Bobtail Shorthair', value: 'American Bobtail Shorthair' },
          { key: 3, text: 'American Shorthair', value: 'American Shorthair' },
          { key: 4, text: 'American Wirehair', value: 'American Wirehair' },
          { key: 5, text: 'Arabian Mau', value: 'Arabian Mau' },
          { key: 6, text: 'Asian Semi-long Hair', value: 'Asian Semi-long Hair' },
          { key: 7, text: 'Australian Mist', value: 'Australian Mist' },
          { key: 8, text: 'Bengal', value: 'Bengal' },
          { key: 9, text: 'Bobtail Japonês', value: 'Bobtail Japonês' },
          { key: 10, text: 'Bombaim', value: 'Bombaim' },
          { key: 11, text: 'Brazilian Shorthair', value: 'Brazilian Shorthair' },
          { key: 12, text: 'British Longhair', value: 'British Longhair' },
          { key: 13, text: 'Burmês', value: 'Burmês' },
          { key: 14, text: 'California Spangled Cat', value: 'California Spangled Cat' },
          { key: 15, text: 'Chausie', value: 'Chausie' },
          { key: 16, text: 'Cornish Rex', value: 'Cornish Rex' },
          { key: 17, text: 'Curl Americano Pelo Curto', value: 'Curl Americano Pelo Curto' },
          { key: 18, text: 'Curl Americano Pelo Longo', value: 'Curl Americano Pelo Longo' },
          { key: 19, text: 'Cymric', value: 'Cymric' },
          { key: 20, text: 'Devon Rex', value: 'Devon Rex' },
          { key: 21, text: 'Domestic Long-Haired', value: 'Domestic Long-Haired' },
          { key: 22, text: 'Domestic Short-Haired', value: 'Domestic Short-Haired' },
          { key: 23, text: 'Don Sphynx', value: 'Don Sphynx' },
          { key: 24, text: 'Egyptian Mau', value: 'Egyptian Mau' },
          { key: 25, text: 'European', value: 'European' },
          { key: 26, text: 'Exotic Shorthair', value: 'Exotic Shorthair' },
          { key: 27, text: 'German Rex', value: 'German Rex' },
          { key: 28, text: 'Havana', value: 'Havana' },
          { key: 29, text: 'Himalaio', value: 'Himalaio' },
          { key: 30, text: 'Khao Manee', value: 'Khao Manee' },
          { key: 31, text: 'Korat', value: 'Korat' },
          { key: 32, text: 'Kurilian Bobtail Longhair', value: 'Kurilian Bobtail Longhair' },
          { key: 33, text: 'Kurilian Bobtail Shorthair', value: 'Kurilian Bobtail Shorthair' },
          { key: 34, text: 'LaPerm Longhair', value: 'LaPerm Longhair' },
          { key: 35, text: 'LaPerm Shorthair', value: 'LaPerm Shorthair' },
          { key: 36, text: 'Maine Coon', value: 'Maine Coon' },
          { key: 37, text: 'Manx', value: 'Manx' },
          { key: 38, text: 'Mekong Bobtail', value: 'Mekong Bobtail' },
          { key: 39, text: 'Munchkin Longhair', value: 'Munchkin Longhair' },
          { key: 40, text: 'Munchkin Shorthair', value: 'Munchkin Shorthair' },
          { key: 41, text: 'Nebelung', value: 'Nebelung' },
          { key: 42, text: 'Norwegian Forest Cat', value: 'Norwegian Forest Cat' },
          { key: 43, text: 'Ocicat', value: 'Ocicat' },
          { key: 44, text: 'Ojos Azules Shorthair', value: 'Ojos Azules Shorthair' },
          { key: 45, text: 'Oriental Longhair', value: 'Oriental Longhair' },
          { key: 46, text: 'Oriental Shorthair', value: 'Oriental Shorthair' },
          { key: 47, text: 'Persa', value: 'Persa' },
          { key: 48, text: 'Peterbald', value: 'Peterbald' },
          { key: 49, text: 'Pixiebob Longhair', value: 'Pixiebob Longhair' },
          { key: 50, text: 'Pixiebob Shorthair', value: 'Pixiebob Shorthair' },
          { key: 51, text: 'Ragamuffin', value: 'Ragamuffin' },
          { key: 52, text: 'Ragdoll', value: 'Ragdoll' },
          { key: 53, text: 'Russo Azul', value: 'Russo Azul' },
          { key: 54, text: 'Sagrado da Birmânia', value: 'Sagrado da Birmânia' },
          { key: 55, text: 'Savannah Cat', value: 'Savannah Cat' },
          { key: 56, text: 'Scottish Fold', value: 'Scottish Fold' },
          { key: 57, text: 'Selkirk Rex Longhair', value: 'Selkirk Rex Longhair' },
          { key: 58, text: 'Selkirk Rex Shorthair', value: 'Selkirk Rex Shorthair' },
          { key: 59, text: 'Serengeti', value: 'Serengeti' },
          { key: 60, text: 'Siamês', value: 'Siamês' },
          { key: 61, text: 'Siberian', value: 'Siberian' },
          { key: 62, text: 'Singapura', value: 'Singapura' },
          { key: 63, text: 'Snowshoe', value: 'Snowshoe' },
          { key: 64, text: 'Sokoke', value: 'Sokoke' },
          { key: 65, text: 'Somali', value: 'Somali' },
          { key: 66, text: 'Sphynx', value: 'Sphynx' },
          { key: 67, text: 'Thai', value: 'Thai' },
          { key: 68, text: 'Tonkinese Shorthair', value: 'Tonkinese Shorthair' },
          { key: 69, text: 'Toyger', value: 'Toyger' },
          { key: 70, text: 'Turkish Angora', value: 'Turkish Angora' },
          { key: 71, text: 'Turkish Van', value: 'Turkish Van' },
          { key: 72, text: 'York Chocolate', value: 'York Chocolate' },
          { key: 73, text: 'Outro', value: 'Outro' },
        ]);
        break;
      default:
        await setBreeds([{ key: 0, text: 'Selecionar', value: '' }]);
        break;
    }
  };

  /**
   * Verifica o tipo de animal
   */
  useEffect(() => {
    if (!isUndefined(forms)) {
      // noinspection JSIgnoredPromiseFromCall
      handleBreed(forms.values.pet.species);
    } else {
      // noinspection JSIgnoredPromiseFromCall
      handleBreed('');
    }
  }, [forms]);

  return (
    <Container onSubmit={(e) => handleSubmit(e)}>
      <Title>Passo 1 de 3: Preencha seus dados</Title>
      <SubTitle>Dados Pessoais</SubTitle>

      <Row>
        <Field
          name={'insurance_holder.name'}
          type={'text'}
          component={InputForm}
          label={'Nome'}
          placeholder={'Nome Completo'}
          validate={[required]}
          required
        />
        <Field
          name={'insurance_holder.birth_date'}
          type={'number'}
          component={InputForm}
          label={'Data de nascimento'}
          placeholder={'00/00/0000'}
          validate={[required]}
          required
          {...birthday}
        />
      </Row>
      <Row>
        <Field
          name={'insurance_holder.cpf'}
          type={'number'}
          component={InputForm}
          label={'CPF'}
          placeholder={'000.000.000-00'}
          validate={[required, number]}
          required
          {...cpf}
        />
        <Field
          name={'insurance_holder.email'}
          type={'email'}
          component={InputForm}
          label={'E-mail'}
          placeholder={'E-mail'}
          validate={[required, email]}
          required
        />
      </Row>

      <hr/>

      <SubTitle>Endereço</SubTitle>
      <Row>
        <Field
          name={'insurance_holder.address.zipcode'}
          type={'number'}
          component={InputForm}
          label={'CEP'}
          placeholder={'00000-000'}
          validate={[required, number]}
          onBlur={(e) => handleLocation(e.target.value)}
          loading={loading}
          required
          {...zipCode}
        />
        <FormGroup style={{width: '100%'}}>
          <div>
            <Field
              name={'insurance_holder.address.street'}
              type={'text'}
              component={InputForm}
              label={'Logradouro'}
              placeholder={'Logradouro'}
              validate={[required]}
              required
            />
          </div>

          <div>
            <Field
              name={'insurance_holder.address.number'}
              type={'number'}
              component={InputForm}
              label={'Número'}
              placeholder={'Número'}
              validate={[required, number]}
              required
            />
          </div>
        </FormGroup>
      </Row>

      <Row grid={'tablet'}>
        <Field
          name={'insurance_holder.address.additional_details'}
          type={'text'}
          component={InputForm}
          label={'Complemento'}
          placeholder={'Ex.: Casa 2'}
        />
        <Field
          name={'insurance_holder.address.city'}
          type={'text'}
          component={InputForm}
          label={'Cidade'}
          placeholder={'Cidade'}
          validate={[required]}
          required
        />
        <Field
          name={'insurance_holder.address.state'}
          type={'text'}
          component={SelectForm}
          label={'Estado'}
          options={[
            {key: 0, text: 'Acre', value: 'AC'},
            {key: 1, text: 'Alagoas', value: 'AL'},
            {key: 2, text: 'Amapá', value: 'AP'},
            {key: 3, text: 'Amazonas', value: 'AM'},
            {key: 4, text: 'Bahia', value: 'BA'},
            {key: 5, text: 'Ceará', value: 'CE'},
            {key: 6, text: 'Distrito Federal', value: 'DF'},
            {key: 7, text: 'Espírito Santo', value: 'ES'},
            {key: 8, text: 'Goiás', value: 'GO'},
            {key: 9, text: 'Maranhão', value: 'MA'},
            {key: 10, text: 'Mato Grosso', value: 'MT'},
            {key: 11, text: 'Mato Grosso do Sul', value: 'MS'},
            {key: 12, text: 'Minas Gerais', value: 'MG'},
            {key: 13, text: 'Pará', value: 'PA'},
            {key: 14, text: 'Paraíba', value: 'PB'},
            {key: 15, text: 'Paraná', value: 'PR'},
            {key: 16, text: 'Pernambuco', value: 'PE'},
            {key: 17, text: 'Pernambuco', value: 'PI'},
            {key: 18, text: 'Rio de Janeiro', value: 'RJ'},
            {key: 19, text: 'Rio Grande do Norte', value: 'RN'},
            {key: 20, text: 'Rio Grande do Sul', value: 'RS'},
            {key: 21, text: 'Rondônia', value: 'RO'},
            {key: 22, text: 'Roraima', value: 'RR'},
            {key: 24, text: 'Santa Catarina', value: 'SC'},
            {key: 25, text: 'São Paulo', value: 'SP'},
            {key: 26, text: 'Sergipe', value: 'SE'},
            {key: 27, text: 'Tocantins', value: 'TO'}
          ]}
          validate={[required]}
          placeholder={'Estado'}
          required
        />
        <Field
          name={'insurance_holder.address.district'}
          type={'text'}
          component={InputForm}
          label={'Bairro'}
          placeholder={'Bairro'}
          validate={[required]}
          required
        />
      </Row>

      <hr/>

      <SubTitle>Informações de Contato</SubTitle>
      <Row>
        <Field
          name={'insurance_holder.phone.phone'}
          type={'numer'}
          component={InputForm}
          label={'Telefone'}
          placeholder={'(00) 0000-0000'}
          validate={[number]}
          {...phone}
        />
        <Field
          name={'insurance_holder.phone.phone_cell'}
          type={'number'}
          component={InputForm}
          label={'Celular'}
          placeholder={'(00) 0 0000-0000'}
          validate={[required]}
          required
          {...phoneCell}
        />
      </Row>

      <hr/>

      <Title>Passo 2 de 3: Pet</Title>

      <Fragment>
        <Field
          name={'pet.name'}
          type={'text'}
          component={InputForm}
          label={'Nome do pet'}
          placeholder={'Nome do pet'}
          validate={[required]}
          required
        />
        <Row>
          <Field
            name={'pet.color'}
            type={'text'}
            component={InputForm}
            label={'Cor do pelo'}
            placeholder={'Cor do pelo'}
            validate={[required]}
            required
          />
          <Field
            name={'pet.size'}
            component={SelectForm}
            label={'Tamanho'}
            placeholder={'Tamanho'}
            options={[
              { key: 0, text: 'Pequeno', value: 'P' },
              { key: 1, text: 'Médio', value: 'M' },
              { key: 2, text: 'Grande', value: 'G' },
            ]}
            validate={[required]}
            required
          />
        </Row>
        <Row>
          <GroupRadioForm
            name={'pet.species'}
            label={'Cão ou Gato'}
            options={[
              { key: 0, text: 'Cão', value: 'Cao' },
              { key: 1, text: 'Gato', value: 'Gato' },
            ]}
          />
        </Row>
        <Field
          name={'pet.birth_date'}
          type={'number'}
          component={InputForm}
          label={'Data de nascimento'}
          placeholder={'00/00/0000'}
          validate={[required, maxAgePet]}
          required
          {...birthday}
        />
        <GroupRadioForm
          name={'pet.gender'}
          label={'Sexo'}
          options={[
            { key: 0, text: 'Macho', value: 'M' },
            { key: 1, text: 'Fêmea', value: 'F' },
          ]}
        />
        <Field
          name={'pet.breed'}
          component={SelectForm}
          label={'Raça'}
          placeholder={'Selecione uma opção'}
          options={breeds}
          validate={[required]}
          required
        />
        <Field
          name={'pet.vaccine'}
          component={SelectForm}
          label={'Está com a vacina em dia?'}
          placeholder={'Selecione uma opção'}
          options={[
            { key: 0, text: 'Sim', value: 'S' },
            { key: 1, text: 'Não', value: 'N' },
          ]}
          validate={[required]}
          required
        />
        <Field
          name={'pet.preexisting_condition'}
          component={TextAreaForm}
          label={'Doença ou lesão preexistente'}
          placeholder={'Descreva'}
        />
      </Fragment>

      <Title>Passo 3 de 3: Voucher</Title>
      <Field
        name={'payment.voucher'}
        component={InputForm}
        label={'Voucher'}
        placeholder={'Insira seu Voucher'}
        validate={[required]}
        required
      />
      <ButtonGroup>
        <Button loading={submit} disabled={invalid || submitting || pristine}>Enviar Formulário</Button>
      </ButtonGroup>

      <Alert ref={alertRef}/>
    </Container>
  );
};

Form.propTypes = {
  handleClose: PropTypes.func.isRequired,
  createToken: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  const { accession } = state.form;

  return {
    forms: accession,
    initialValues: {
      pet: {
        size: '',
        breed: '',
        color: '',
        gender: '',
        species: '',
        birth_date: '',
        preexisting_condition: '',
        name: '',
        vaccine: '',
      },
      insurance_holder: {
        phone: {
          phone: '',
          phone_cell: '',
        },
        address: {
          city: '',
          state: '',
          number: '',
          street: '',
          zipcode: '',
          district: '',
          additional_details: '',
        },
        cpf: '',
        name: '',
        email: '',
        birth_date: '',
      },
      payment: {
        voucher: '',
      },
      product_data: {
        9: {
          insured_amount: 0,
          coverages: {
            'dad3305b-6c2b-421c-8c1a-9cc2eaef4098': {
              value: 0,
              deductible: 0,
            },
          },
        },
      },
      product_ids: [
        9,
      ],
    },
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'accession',
  enableReinitialize: true,
})(Form));